import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import ChatWidget from "@/components/ChatWidget";
import AlignmentGuide from "@/components/AlignmentGuide";
import Home from "@/pages/Home";
import Blogs from "@/pages/Blogs";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import ServicePage from "@/pages/ServicePage";

const AppShell = () => {
  const location = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    if (lenisRef.current) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  }, []);

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el && window.__lenis) {
        setTimeout(() => window.__lenis.scrollTo(el, { offset: -100 }), 350);
        return;
      }
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  return (
    <div className="App">
      <div className="bg-stripes" aria-hidden="true" />
      <AlignmentGuide />
      <Navbar />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:slug" element={<BlogDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/services/:slug" element={<ServicePage />} />
        </Routes>
      </AnimatePresence>
      <ChatWidget />
      <Toaster position="bottom-right" richColors />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
